<template>
    <!-- プレビュー以外 -->
    <div v-if="!isPreviewPage">
        <div class="flex flex-col min-h-screen bg-base relative">
            <header class="bg-white shadow">

                <nav class="mx-auto px-4 py-3 flex justify-between items-center">

                    <!-- メニューボタン（SPでログイン時のみ表示） -->
                    <div class="md:hidden flex gap-2 items-center">
                        <div v-if="!isLoginRelatedPage && !isGaidelinePage">
                            <button @click="toggleMenu" class="text-emerald-600 hover:text-emerald-700">
                                <i class="fa-solid fa-bars text-lg"></i>
                            </button>
                        </div>

                        <ChannelList :channels="channels" :is-mobile="isMobile" />
                    </div>

                    <!-- ロゴ（常に表示、SPでは中央に配置） -->
                    <div class="absolute left-1/2 transform -translate-x-1/2 md:relative md:left-auto md:transform-none md:flex-grow">
                        <router-link to="/" class="text-emerald-600 hover:text-emerald-700">
                            <img :src="logo" alt="Logo" class="h-8" style="width: 108px;" />
                        </router-link>
                    </div>

                    <div class="flex justify-between items-center gap-4">
                        <!-- ログアウトボタン（ログイン時のみ表示、右端に配置） -->
                        <div class="link-styles--gray">
                            <button v-if="!isLoginRelatedPage && !isGaidelinePage" @click="handleAuthAction" type="button"
                                class="flex items-center gap-1 cursor-pointer text-sm">
                                <i class="fa-light fa-arrow-right-from-bracket"></i>
                                <span class="hidden md:inline whitespace-nowrap">ログアウト</span>
                            </button>
                        </div>
                        <!-- ヘルプ -->
                        <a href="https://note.com/livedoor_echoes/m/m1d8d4ed94dc8" target="_blank"
                            class="link-styles--gray flex items-center gap-1 cursor-pointer text-sm">
                            <i class="fa-light fa-circle-question"></i>
                            <span class="hidden md:inline whitespace-nowrap">ヘルプ</span>
                        </a>
                    </div>
                </nav>
            </header>

            <!-- ガイドライン以外 -->
            <div class="flex-1" v-if="!isGaidelinePage">
                <div class="flex flex-col md:flex-row">
                    <!-- メニュー -->
                    <nav v-if="!isLoginRelatedPage" :class="{'block w-full': isMenuOpen, 'hidden': !isMenuOpen}" class="md:block p-6">
                        <ul class="bg-transparent">
                            <li v-if="isLoadingChannels" class="group font-normal py-2">
                                <DataLoading />
                            </li>
<li v-if="!isMobile" id="pc-channel-list" class="group font-normal py-2 relative overflow-visible">                                <ChannelList :channels="channels" :is-mobile="isMobile" />
                            </li>
                            <template v-if="hasChannel()">
                                <li class="group font-normal">
                                    <router-link to="/video-management" class="flex items-center w-full md:w-52 h-11 px-4 rounded-lg hover:bg-muted group-active:bg-muted gap-4" @click="closeMenu" active-class="bg-muted font-bold">
                                        <i class="fa-light fa-video h-4 w-4"></i>
                                        <span>動画管理</span>
                                    </router-link>
                                </li>
                                <li class="group font-normal">
                                    <router-link to="/article-management" class="flex items-center w-full md:w-52 h-11 px-4 rounded-lg hover:bg-muted group-active:bg-muted gap-4" @click="closeMenu" active-class="bg-muted font-bold">
                                        <i class="fa-light fa-newspaper h-4 w-4"></i>
                                        <span>記事管理</span>
                                    </router-link>
                                </li>
                                <li class="group font-normal">
                                    <router-link to="/channel-management" class="flex items-center w-full md:w-52 h-11 px-4 rounded-lg hover:bg-muted group-active:bg-muted gap-4" @click="closeMenu" active-class="bg-muted font-bold">
                                        <i class="fa-light fa-address-card h-4 w-4"></i>
                                        <span>チャンネル管理</span>
                                    </router-link>
                                </li>
                                <li v-if="isOwnerChannel" class="group font-normal">
                                    <router-link to="/member-management" class="flex items-center w-full md:w-52 h-11 px-4 rounded-lg hover:bg-muted group-active:bg-muted gap-4" @click="closeMenu" active-class="bg-muted font-bold">
                                        <img :src="user_group" alt="user group" class="h-4 w-4" />
                                        <span>メンバー管理</span>
                                    </router-link>
                                </li>
                            </template>
                            <li class="group font-normal">
                                <router-link to="/information" class="flex items-center w-full md:w-52 h-11 px-4 rounded-lg hover:bg-muted group-active:bg-muted gap-4" @click="closeMenu" active-class="bg-muted font-bold">
                                    <i class="fa-light fa-bell"></i>
                                    <span>お知らせ</span>
                                </router-link>
                            </li>
                        </ul>
                    </nav>
                    <div class="w-full mb-20">
                        <router-view />
                        <MemberInvitationModal v-if="!isLoginRelatedPage" @accept-invitation="handleAcceptInvitation"/>
                    </div>
                </div>
            </div>

            <!-- ガイドライン用 -->
            <div v-else>
                <div class="flex flex-col min-h-screen bg-base">
                    <!-- メインコンテンツ -->
                    <div class="flex flex-col md:flex-row flex-1 ">
                        <div class="w-full mb-20">
                            <router-view />
                        </div>
                    </div>
                </div>
            </div>

            <!-- 共通 -->
            <footer class="p-4 flex flex-wrap justify-center text-sm gap-4">
                <div class="flex flex-wrap justify-center gap-x-4 gap-y-2 mr-auto">
                    <a href="https://livedoor.co.jp/" target="_blank" class="link-styles--gray">運営会社</a>
                    <a href="https://www.livedoor.com/rules/" target="_blank" class="link-styles--gray">利用規約</a>
                    <a href="https://www.livedoor.com/privacy/" target="_blank" class="link-styles--gray">プライバシーポリシー</a>
                    <a href="/guideline" class="link-styles--gray">ガイドライン</a>
                </div>
                <div class="text-gray-400">© livedoor</div>
            </footer>
        </div>
    </div>

    <!-- プレビュー画面用 -->
    <div v-else>
        <div class="flex flex-col min-h-screen bg-base">
            <!-- メインコンテンツ -->
            <div class="flex flex-col md:flex-row flex-1 ">
                <div class="w-full mb-20">
                    <router-view />
                </div>
            </div>
        </div>
    </div>

    </template>



    <script>
    import { ref, computed, onMounted, onBeforeUnmount, watch, getCurrentInstance, provide } from 'vue';
    import { useStore } from 'vuex';
    import { useRouter,useRoute } from 'vue-router';
    import axios from 'axios';
    import { isLogin } from './composables/userCheckAuth';
    import logo from '@/assets/echoes_icon.svg';
    import user_group from '@/assets/user_group.svg';
    import { BASE_URL_DEV, BASE_URL_LOCAL, BREAK_POINT_MD } from '@/plugins/constants';
    import ChannelList from './components/ChannelList.vue'
    import DataLoading from './components/DataLoading.vue'
    import MemberInvitationModal from './components/MemberInvitationModal.vue';

    export default {
        components: {
            ChannelList,
            DataLoading,
            MemberInvitationModal,
        },
        setup() {
            const isMenuOpen = ref(false);
            const toggleMenu = () => {
                isMenuOpen.value = !isMenuOpen.value;
            };
            function closeMenu() {
                isMenuOpen.value = false;
            }

            const store = useStore();
            const router = useRouter();
            const route = useRoute();
            const isAuthenticated = computed(() => store.state.isAuthenticated);
            const isTokenExpired = computed(() => store.state.isTokenExpired);
            const accessToken = store.state.accessToken;
            const apiEndpoint = process.env.VUE_APP_API_ENDPOINT;

            let tokenTimer = null;
            // インスタンスを取得
            const instance = getCurrentInstance();

            // トークン有効期限チェック関数
            const startTokenExpiryCheck = () => {
                // すでにタイマーが存在する場合はクリア
                if (tokenTimer) {
                    clearInterval(tokenTimer);
                }

                // 5分ごとにチェック
                tokenTimer = setInterval(() => {
                    // ユーザー情報の取得
                    const authTypes = JSON.parse(localStorage.getItem('auth_types') || '{}');
                    const email = localStorage.getItem('current_user_email');
                    const userAuthType = email ? authTypes[email] : null;

                    // tokenフローユーザーの場合
                    if (userAuthType === 'token') {
                        const tokenLoginTime = parseInt(localStorage.getItem('token_login_time') || '0');
                        const now = Date.now();
                        // Googleアクセストークンの有効期限（通常1時間）
                        const tokenExpiry = tokenLoginTime + (3600 * 1000); // 1時間

                        // 残り時間（ミリ秒）
                        const timeLeft = tokenExpiry - now;

                        if (timeLeft <= 0) {
                            // 期限切れの場合
                            clearInterval(tokenTimer);
                            // ログアウト処理
                            store.dispatch('logout').then(() => {
                                // ログイン画面にリダイレクト
                                router.push({
                                    name: 'Login',
                                    query: { expired: 'token' }
                                });
                            });
                        } else if (timeLeft <= 600000) { // 残り10分以内 600000
                            // 警告通知
                            showTokenExpiryWarning(Math.floor(timeLeft / 60000));
                        }
                    }
                }, 300000); // 5分ごとにチェック 300000
            };

            // 警告通知を表示する関数
            const showTokenExpiryWarning = (minutesLeft) => {
                // コンソールに出力
                console.warn(`セッション有効期限まであと約${minutesLeft}分です`);

                // トースト通知
                if (instance && instance.appContext.config.globalProperties.$toast) {
                    instance.appContext.config.globalProperties.$toast.warning(
                    `セッション有効期限まであと約${minutesLeft}分です。作業を保存し、再ログインしてください。`,
                    { duration: 10000 } // 10秒間表示
                    );
                } else {
                    // トースト通知がなければアラートを使用
                    alert(`セッション有効期限まであと約${minutesLeft}分です。作業を保存し、再ログインしてください。`);
                }

                /*
                // ブラウザ通知も検討
                if ('Notification' in window && Notification.permission === 'granted') {
                    new Notification('セッション有効期限が近づいています', {
                        body: `セッション有効期限まであと約${minutesLeft}分です。作業を保存し、再ログインしてください。`,
                        icon: '/favicon.ico' // アプリのアイコン
                    });
                }
                    */

                // コンソールにも出力
                console.warn(`セッション有効期限まであと約${minutesLeft}分です`);
            };

            // ログイン状態の監視
            watch(() => store.state.isAuthenticated, (newValue) => {
                if (newValue && isLogin()) {
                    // ログイン状態になったらチェック開始
                    startTokenExpiryCheck();
                } else {
                    // ログアウト状態になったらタイマー停止
                    if (tokenTimer) {
                        clearInterval(tokenTimer);
                        tokenTimer = null;
                    }
                }
            }, { immediate: true });

            // コンポーネント初期化時
            onMounted(() => {
                if (isLogin()) {
                    startTokenExpiryCheck();
                }

                // 通知許可の確認・リクエスト
                /*if ('Notification' in window && Notification.permission !== 'granted' && Notification.permission !== 'denied') {
                    Notification.requestPermission();
                }*/
            });

            // コンポーネント破棄時
            onBeforeUnmount(() => {
                if (tokenTimer) {
                    clearInterval(tokenTimer);
                    tokenTimer = null;
                }
            });

            const handleAuthAction = () => {
                if (!isAuthenticated.value || isTokenExpired.value) {
                    router.push('/login');
                } else {
                    store.dispatch('clearregisterdata');
                    store.dispatch('logout');
                    clearChannels();
                    router.push({
                        name: 'Login'
                    });
                }
            };

            // 現在のページがログイン関連ページかどうかを判断するcomputedプロパティ
            const isLoginRelatedPage = computed(() => {
                return ['Login', 'RegistrationComplete', 'AccountCreation', 'AccountCreated'].includes(route.name);
            });

            // 現在のページがプレビューページかどうかを判断するcomputedプロパティ
            const isPreviewPage = computed(() => {
                return ['ArticlePreview'].includes(route.name);
            });

            // 現在のページがガイドラインページかどうかを判断するcomputedプロパティ
            const isGaidelinePage = computed(() => {
                return ['UserGuideline'].includes(route.name);
            });

            onMounted(() => {
                const baseUrl = window.location.origin;
                if(baseUrl === BASE_URL_DEV){
                    document.title = "ECHOES（dev）";
                }else if(baseUrl == BASE_URL_LOCAL){
                    document.title = "ECHOES（local）";
                }
            })

            const isMobile = ref(false);

            const checkScreenSize = () => {
                isMobile.value = window.innerWidth < BREAK_POINT_MD;
            }

            onMounted(() => {
                checkScreenSize()
                window.addEventListener('resize', checkScreenSize)
            })

            const channels = ref([]);
            const isLoadingChannels = ref(false);

            const fetchChannels = async (accessToken) => {
                try {
                    isLoadingChannels.value = true;
                    const response = await axios.get(`${apiEndpoint}/channels/`, {
                        headers: {
                            'Authorization': `Bearer ${accessToken}`
                        }
                    });
                    if(response.status == 200) {
                        channels.value = response.data;
                        console.log(channels.value);
                        isLoadingChannels.value = false;
                        return channels.value;
                    }
                } catch (error) {
                    console.error("チャンネル情報の取得に失敗しました。", error);
                    isLoadingChannels.value = false;
                    channels.value = [];

                    return channels.value;
                }
            };

            provide("fetchChannels", fetchChannels);

            const isOwnerChannel = computed(() => {
                const currentChannel = channels.value.find((ch) => ch.is_current === true);
                if (currentChannel) {
                    return currentChannel.is_owner || false;
                } else {
                    return false;
                }
            });

            const clearChannels = () => {
                channels.value = [];
            };

            onMounted(() => {
                fetchChannels(accessToken);
            });

            const hasChannel = () => {
                return channels.value && (channels.value.length > 0);
            };

            const handleAcceptInvitation = () => {
                window.location.href = "/video-management";
            };

            return {
                isMenuOpen,
                closeMenu,
                toggleMenu,
                handleAuthAction,
                logo,
                user_group,
                isLoginRelatedPage,
                isPreviewPage,
                isGaidelinePage,
                hasChannel,
                isMobile,
                channels,
                isLoadingChannels,
                isOwnerChannel,
                handleAcceptInvitation,
            };
        }
    };

    </script>

